/**
 * @fileoverview Definições dos templates de Board (CRM Kanban) usados pelo modal
 * de criação. As mesmas chaves existem no backend (constants/boardTemplates.ts);
 * o frontend usa apenas as colunas para *preview* — a criação real é semeada no
 * backend a partir da chave do template.
 */

export const BOARD_TEMPLATE_KEYS = {
  LEADS: "leads",
  TASKS: "tasks"
};

export const leadManagementTemplate = {
  key: BOARD_TEMPLATE_KEYS.LEADS,
  title: "Gestão de Leads",
  description:
    "Ideal para acompanhar oportunidades comerciais, contatos, propostas e negociações.",
  defaultBoardName: "Pipeline de Vendas",
  defaultColor: "#5B7CFF",
  columns: [
    "Novo Lead",
    "Contato Iniciado",
    "Qualificação",
    "Proposta Enviada",
    "Negociação",
    "Ganho",
    "Perdido"
  ]
};

export const taskManagementTemplate = {
  key: BOARD_TEMPLATE_KEYS.TASKS,
  title: "Gestão de Tarefas",
  description:
    "Ideal para organizar demandas, tarefas internas, produção, revisões, aprovações e entregas.",
  defaultBoardName: "Gestão de Tarefas",
  defaultColor: "#5B7CFF",
  columns: [
    "Backlog",
    "A Fazer",
    "Em Andamento",
    "Em Revisão",
    "Aguardando",
    "Concluído"
  ]
};

export const BOARD_TEMPLATES = [leadManagementTemplate, taskManagementTemplate];

export const getTemplateByKey = (key) =>
  BOARD_TEMPLATES.find((t) => t.key === key) || null;
